import { baseApi } from "../../../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../../../core/data/rtk/apiResponseType";
import { InvoicesResponse, Invoice } from "../types/invoiceTypes";

// Updated payload interface to match the exact API requirements
export interface UpdateInvoicePayload {
  discount_type: "fixed" | "percent";
  discount_value: number;
  amount: number;
  payable: number;
  invoice_date: string;
  due_date: string;
}

export const invoiceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInvoicesByStudentId: builder.query<
      ApiResponseType<InvoicesResponse>,
      string
    >({
      query: (studentId) => ({
        url: `invoices/get-by-studentid/${studentId}`,
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.invoices.map(({ id }) => ({
                type: "Invoices" as const,
                id,
              })),
              { type: "Invoices", id: "LIST" },
            ]
          : [{ type: "Invoices", id: "LIST" }],
    }),

    getInvoiceById: builder.query<
      ApiResponseType<{ invoice: Invoice }>,
      string
    >({
      query: (invoiceId) => ({
        url: `invoices/get/${invoiceId}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Invoices", id }],
    }),

    // Updated update invoice endpoint with exact payload format
    updateInvoice: builder.mutation<
      ApiResponseType<{ invoice: Invoice }>,
      { id: string; updateData: UpdateInvoicePayload }
    >({
      query: ({ id, updateData }) => ({
        url: `invoices/update/${id}`,
        method: "PUT",
        body: updateData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Invoices", id },
        { type: "Invoices", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetInvoicesByStudentIdQuery,
  useGetInvoiceByIdQuery,
  useLazyGetInvoicesByStudentIdQuery,
  useLazyGetInvoiceByIdQuery,
  useUpdateInvoiceMutation,
} = invoiceApi;
